import { getPropertyOtherLocaleUrls } from '@dreamstack/feature-components/src/property/routing/getPropertyUrl'
import type { EquipmentFeature } from '@dreamstack/feature-components/src/property/EquipmentFeatures'
import type { FullProperty } from '@dreamstack/web/lib/prisma/properties'
import filter from 'lodash/filter'
import map from 'lodash/map'
import { ProductJsonLd } from 'next-seo'
import type { FunctionComponent } from 'react'
import {
  getItemAvailabilityForStatus,
  MARKUP_IMAGE_UPPER_BOUND,
} from './MarkupUtil'

export const PropertyRichMarkup: FunctionComponent<
  React.PropsWithChildren<{
    property?: FullProperty | null
    id: number
  }>
> = ({ property, id }) => {
  if (!property) return null
  const name = property.title ?? ''
  const description = property.description_note
  const imageUrls = map(property.property_images, (images) => images.url).slice(
    0,
    MARKUP_IMAGE_UPPER_BOUND
  )
  const url = getPropertyOtherLocaleUrls({ id, city: property.city ?? '' })
  const price = property.price
  const addressLocality = property.location_name
  const addressRegion = property.region
  const postalCode = property.zip_code
  const streetAddress = property.street + ' ' + property?.house_number
  const numberOfRooms = property.number_of_rooms

  let equipmentFeatures: EquipmentFeature[] = property.equipment_features || []
  equipmentFeatures = filter(equipmentFeatures, (f) => !!f.value && !!f.label)

  const amenityFeatures = map(equipmentFeatures, (features) => features.label)

  const geoCoordinates = property?.geoLocation
  const floorSize = property.property_space_value

  const availability = getItemAvailabilityForStatus(property.status ?? 0)

  return (
    <ProductJsonLd
      productName={name}
      brand="Accentro GmbH"
      description={description ?? undefined}
      images={imageUrls}
      offers={{
        url: url,
        priceCurrency: 'EUR',
        price: price,
        availability: availability,
        address: {
          addressCountry: 'DE',
          addressLocality: addressLocality,
          addressRegion: addressRegion,
          postalCode: postalCode,
          streetAddress: streetAddress,
          numberOfRooms: numberOfRooms,
          amenityFeatures: amenityFeatures,
          geo: geoCoordinates,
          floorSize: {
            floorSize,
            unitCode: 'MTK',
          },
        },
      }}
    />
  )
}
